import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import * as moment from "moment"
import { isEmpty, size } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Button,
  Card,
  CardBody,
  Col,
  CardTitle,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import useInfiniteScroll from "components/Common/useInfiniteScroll"
import ReportDayPicker from "components/Common/ReportDayPicker"

import { getReport } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const DayReport = props => {
  const dispatch = useDispatch()
  const limit = 100;
  useEffect(() => {
    
    getDayReport({
      startDate : moment(new Date()).format("yyyy-MM-DD"),
      endDate : moment(new Date()).format("yyyy-MM-DD"),
      limit : limit,
      lastId : 0
    })
  }, []);

  const getDayReport = (input) => {
    setIsLoading(true)
    setSelectedDate({
      startDate:input.startDate,
      endDate: input.endDate,
    })
    getReport(input,'dayreport').then(resp => {
      if(resp.length > 0){
        let lastItem = resp[resp.length-1]
        let lastRow = lastItem[lastItem.length-1]
        setLastId(lastRow.id)
        setDayRecords(oldArray => [...oldArray, ...resp])
      }
      else if(resp.length == 0){
        setNoMoreData(true)
      }
      setIsFetching(false)
      setIsLoading(false)
    })
  }

  function fetchMoreListItems() {
    if(!isLoading && !noMoreData){
      getDayReport({
        startDate : selectedDate.startDate,
        endDate : selectedDate.endDate,
        limit : limit,
        lastId : lastId
      })
    }
    else{
      //console.log('not fetching..')
    }
    
  }
  
  const [isFetching, setIsFetching] = useInfiniteScroll(fetchMoreListItems);
  const [isLoading, setIsLoading] = useState(false)
  const [noMoreData, setNoMoreData] = useState(false)
  const [lastId, setLastId] = useState(0)
  const [dayRecords, setDayRecords] = useState([])
  const [selectedDate, setSelectedDate] = useState({
    startDate : moment(new Date()).format("yyyy-MM-DD"),
    endDate : moment(new Date()).format("yyyy-MM-DD"),
  })

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  const onConfirmSelectedDates = (dates) => {
    setDayRecords([])
    setNoMoreData(false)
    getDayReport({
      startDate : dates.startDate,
      endDate : dates.endDate,
      limit : limit,
      lastId : 0
    })
    //setCurrentAddedValue(value)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Day Book | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Reports" breadcrumbItem="Day Book" />
          
          <Row>
            <Col xs="12">
              <Card>
                <CardTitle className="mt-0">
                  <Row className="mt-2">
                    <Col xs="4">
                      
                    </Col>
                    <Col xs="4" className="text-center align-middle align-self-center">
                      Day Book
                    </Col>
                    <Col xs="4" className="text-end d-inline-block pe-3">
                      <ReportDayPicker 
                      onConfirmSelectedDates={onConfirmSelectedDates}
                      loadInProgress={isLoading}
                      /> 
                    </Col>
                  </Row>
                </CardTitle>

                <CardBody style={{minHeight:450}}>
                  <Row>
                    <Col lg="12">
                    <Table className="project-list-table table-sm table-nowrap align-middle table-borderless">
                      <thead>
                            <tr >
                              <th scope="col" style={{ width: "100px" }}>
                                Date
                              </th>
                              <th scope="col" style={{ width: "100px" }}>#</th>
                              <th scope="col" style={{ width: "100px" }}>Account</th>
                              <th scope="col" style={{ width: "100px" }}>Debit</th>
                              <th scope="col" style={{ width: "100px" }}>Credit</th>
                            </tr>
                            <tr>
                              <td colSpan={5}>
                                <hr className="my-0"/>
                              </td>
                            </tr>
                      </thead>
                      <tbody>
                      {map(dayRecords, (record, index) => (
                        <React.Fragment key={index}>
                          {map(record, (row, inner) => (
                          <tr key={inner} className="p-0">
                            <td className="p-0 m-0">
                              {inner == 0 ? handleValidDate(row.txnDate) : ''}
                            </td>
                            <td className="p-0 m-0">
                            {inner == 0 ? <>
                              <div>{row.txnNo}</div>
                              <div className="text-muted">{row.txnType}</div>
                              </>
                              :null
                              }
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'C' ? <div className="ms-3">{row.description}</div> : <div className="ms-0">{row.description}</div>}
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'D' ? Number(row.debitAmt).toLocaleString('en-IN',{minimumFractionDigits: 2}) : ''}
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'C' ? Number(row.creditAmt).toLocaleString('en-IN',{minimumFractionDigits: 2}) : ''}
                            </td>
                          </tr>
                          ))}
                          <tr>
                            <td colSpan={5}>
                              <hr className="my-0"/>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                      </tbody>
                    </Table>
                    </Col>
                  </Row>
                  {isLoading && <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <div className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Loading...
                        </div>
                      </div>
                    </Col>
                  </Row>}
                  {noMoreData && <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <div className="text-success">
                        -- <i className="fas fa-hourglass-end" /> --
                        </div>
                      </div>
                    </Col>
                  </Row>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

DayReport.propTypes = {
}

export default withRouter(DayReport)
